var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCussParkingMeters = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m14 13 5.155-6L24 8v15H14zM4.148 6.727c.217-.814.73-1.236 1.868-1.215.672.012 1.232.328 1.68.984L8.728 8.08a4.9 4.9 0 0 0 1.728 1.752 4.83 4.83 0 0 0 2.544.696v1.968A7.14 7.14 0 0 1 7.528 10l-.624 3 2.112 2.016v7.512H7v-6l-1.997-2.016v8.016H2.824l.098-9.658.886-4.454zm3.38-1.743a1.98 1.98 0 0 1-1.416-.576 1.86 1.86 0 0 1-.6-1.392q0-.816.6-1.416T7.528 1t1.416.612.6 1.404-.612 1.38-1.404.588",
  clipRule: "evenodd"
})));
export default SvgCussParkingMeters;